import React from "react";
import AuditLog from "./AuditLog";
import PlansEditor from "./PlansEditor";
import BrandingEditor from "./BrandingEditor";
import AddonPricesEditor from "./AddonPricesEditor";
import ConfigurationSettings from "./ConfigurationSettings";

// Platform settings (Super Admin): plan prices, Ownezzy's logos and the audit trail
export default function SettingsTab({ notify }) {
  return (
    <>
      <div className="page-heading">
        <div>
          <p className="eyebrow">ACCOUNT SETTINGS</p>
          <h1>Platform settings</h1>
          <p className="subheading">Set plan prices, change Ownezzy's logos and review sensitive activity.</p>
        </div>
      </div>
      <PlansEditor notify={notify} />
      <AddonPricesEditor notify={notify} />
      <ConfigurationSettings notify={notify} />
      <BrandingEditor notify={notify} />
      <AuditLog />
    </>
  );
}
